document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav-main] .nav-main');
  var overlay = document.querySelector('[data-nav-overlay]');

  function closeNav() {
    if (nav) nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      if (overlay) overlay.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
  if (overlay) overlay.addEventListener('click', closeNav);

  // Mobile dropdown toggles (tap to expand submenu instead of hover)
  document.querySelectorAll('[data-nav-parent] > a, [data-nav-parent] .nav-main__lang-toggle').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.innerWidth > 989) return;
      var parent = link.closest('[data-nav-parent]');
      if (!parent.querySelector('.nav-dropdown')) return;
      e.preventDefault();
      parent.classList.toggle('is-open');
    });
  });

  // Cookie consent banner
  var banner = document.querySelector('[data-cookie-banner]');
  if (banner) {
    var STORAGE_KEY = 'carnavalexperience_cookie_consent';
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      banner.classList.add('is-visible');
    }
    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        window.localStorage.setItem(STORAGE_KEY, '1');
        banner.classList.remove('is-visible');
      });
    }
  }

  // Product page: media gallery, variant picker and quantity stepper
  document.querySelectorAll('.product').forEach(function (root) {
    // Media gallery
    var mediaImages = root.querySelectorAll('.product__media-image[data-media-id]');
    var thumbs = root.querySelectorAll('[data-media-thumb]');

    function showMedia(mediaId) {
      mediaImages.forEach(function (img) {
        var match = img.getAttribute('data-media-id') === String(mediaId);
        img.hidden = !match;
        img.classList.toggle('is-active', match);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-id'));
      });
    });

    var prevBtn = root.querySelector('[data-media-prev]');
    var nextBtn = root.querySelector('[data-media-next]');
    if (prevBtn && nextBtn && thumbs.length) {
      var currentIndex = function () {
        var idx = 0;
        thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) idx = i; });
        return idx;
      };
      prevBtn.addEventListener('click', function () {
        thumbs[(currentIndex() - 1 + thumbs.length) % thumbs.length].click();
      });
      nextBtn.addEventListener('click', function () {
        thumbs[(currentIndex() + 1) % thumbs.length].click();
      });
    }

    // Quantity stepper
    var qtyInput = root.querySelector('[data-quantity-input]');
    var minusBtn = root.querySelector('[data-quantity-minus]');
    var plusBtn = root.querySelector('[data-quantity-plus]');
    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      plusBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    // Variant picker
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantIdInput = root.querySelector('[data-product-variant-id]');
    var priceWrap = root.querySelector('[data-product-price]');
    var availabilityEl = root.querySelector('[data-product-availability]');
    var skuEl = root.querySelector('[data-product-sku]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addBtnText = root.querySelector('[data-add-to-cart-text]');
    var optionInputs = root.querySelectorAll('[data-option-input]');

    function getSelectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-position]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(selected) {
      return variants.filter(function (v) {
        var vOpts = [v.option1, v.option2, v.option3].slice(0, selected.length);
        return vOpts.every(function (val, i) { return val === selected[i]; });
      })[0];
    }

    function updateUI(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML =
            '<span class="product__price-compare">' + variant.compare_at_price_formatted + '</span>' +
            '<span class="product__price-current product__price-current--sale">' + variant.price_formatted + '</span>';
        } else {
          priceWrap.innerHTML = '<span class="product__price-current">' + variant.price_formatted + '</span>';
        }
      }

      if (availabilityEl) {
        availabilityEl.textContent = availabilityEl.dataset[variant.available ? 'inStockLabel' : 'outOfStockLabel'] || availabilityEl.textContent;
      }
      if (skuEl) {
        skuEl.hidden = !variant.sku;
        if (variant.sku) skuEl.textContent = skuEl.dataset.skuLabel ? skuEl.dataset.skuLabel + ' ' + variant.sku : skuEl.textContent;
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) {
        addBtnText.textContent = variant.available
          ? (addBtnText.dataset.addLabel || addBtnText.textContent)
          : (addBtnText.dataset.soldOutLabel || addBtnText.textContent);
      }

      if (variant.featured_media_id) {
        var thumb = root.querySelector('[data-media-thumb][data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var fieldset = input.closest('[data-option-position]');
        if (fieldset) {
          fieldset.querySelectorAll('.variant-pill').forEach(function (pill) { pill.classList.remove('is-selected'); });
        }
        var pill = input.closest('.variant-pill');
        if (pill) pill.classList.add('is-selected');
        updateUI(findVariant(getSelectedOptions()));
      });
    });
  });

  // Cart drawer: open/close, add to cart (AJAX) and quantity/remove
  var cartRoot = document.querySelector('[data-cart-drawer-root]');

  function cartUrls() {
    return {
      add: (cartRoot && cartRoot.dataset.cartAddUrl) || '/cart/add.js',
      change: (cartRoot && cartRoot.dataset.cartChangeUrl) || '/cart/change.js',
      cart: (cartRoot && cartRoot.dataset.cartUrl) || '/cart'
    };
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function refreshCart(openAfter) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });

    if (!cartRoot) return;
    fetch(cartUrls().cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        cartRoot.innerHTML = html;
        if (openAfter) openCartDrawer();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;

    fetch(cartUrls().add, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        if (submitBtn) submitBtn.disabled = false;
        if (result.status) {
          alert(result.description || 'Não foi possível adicionar o produto ao carrinho.');
          return;
        }
        refreshCart(true);
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        form.submit();
      });
  });

  function updateCartLine(el, quantity) {
    var line = el.dataset.line;
    var isCartPage = !!el.closest('.cart-page');

    fetch(cartUrls().change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (isCartPage) {
          window.location.reload();
        } else {
          refreshCart(true);
        }
      });
  }

  function adjustCartLine(el, delta) {
    var line = el.dataset.line;
    var input = document.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
    var current = input ? parseInt(input.value, 10) || 0 : 0;
    updateCartLine(el, Math.max(0, current + delta));
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openCartDrawer();
      return;
    }

    var closeBtn = e.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    var minusBtn = e.target.closest('[data-cart-qty-minus]');
    if (minusBtn) {
      adjustCartLine(minusBtn, -1);
      return;
    }

    var plusBtn = e.target.closest('[data-cart-qty-plus]');
    if (plusBtn) {
      adjustCartLine(plusBtn, 1);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      updateCartLine(removeBtn, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-qty-input]');
    if (qtyInput) {
      var qty = Math.max(0, parseInt(qtyInput.value, 10) || 0);
      updateCartLine(qtyInput, qty);
    }
  });
});
